// Centralized configuration for interview workflow
// AI Detection Settings
export const AI_CONFIDENCE_THRESHOLD = parseFloat(
  import.meta.env.VITE_AI_DETECT_CONF ?? "0.70",
);
export const DETECTOR_COOLDOWN_MS = 10_000; // Min time between AI detection calls
export const DETECTOR_MAX_PER_MIN = 6; // Max detection calls per minute

// Suggestion Display
export const SUGGESTIONS_PER_BUCKET = 3; // Max questions per priority bucket
export const MAX_TOTAL_SUGGESTIONS = 20; // Cap on total suggestions
export const RECENT_SUGGESTION_TTL_MS = 90_000; // Don't re-show dismissed for 90s

// Suggestion Refresh Timing (useSuggestionsRefresh.ts)
export const SUGGESTIONS_READY_SECONDS = 15; // Min seconds before first suggestions fetch
export const SUGGESTIONS_READY_MIN_UTTERANCES = 2; // Min utterances before suggestions ready
export const SUGGESTIONS_THROTTLE_MS = 20_000; // Max time between suggestion fetches
export const SUGGESTIONS_UTT_DELTA = 5; // Fetch after this many new utterances
export const SUGGESTIONS_FETCH_DEBOUNCE_MS = 500; // Debounce for utterance-driven fetch
export const SUGGESTIONS_CASE_STATE_THROTTLE_MS = 9_000; // Case-state driven throttle
export const SUGGESTIONS_CASE_STATE_DEBOUNCE_MS = 2_000; // Case-state debounce 

// Answer Extraction
export const ANSWER_WINDOW_MS = 45_000; // How long after question to look for answer
export const EXTRACTION_DEBOUNCE_MS = 3_000; // Debounce for live field extraction

// Grounding
export const MIN_PHONE_DIGITS_FOR_GROUNDING = 7; // Phone must have 7+ digits to be grounded
